<template>
  <div class="text-gray-600">
    <template v-if="paymentIsPending">
      <div class="px-5">
        <p
          class="ota-p16 mb-7 text-center"
          v-text="$t('Loyalty.Webshop.Checkout.PaymentPending')"
        />
      </div>
    </template>
    <template v-else>
      <div class="px-5">
        <h1 class="ota-p18 font-bold mb-rem md:mb-5" v-text="$t('Loyalty.Webshop.Checkout.Confirmation')" />
        <p
          class="ota-p16 mb-7"
          v-html="$t('Loyalty.Webshop.Checkout.ConfirmationDescription', {
            from: deliveryTimes.from,
            to: deliveryTimes.to,
          })"
        />
        <WebshopOrderSummary :products="products" />
      </div>
      <WebshopReceipt v-bind="receiptProps" />
    </template>
  </div>
</template>

<script>
import { GET_LOYALTY_ORDER_INFORMATION } from '@/utils/store/actionTypes'
import { RESET_CART } from '@/utils/store/mutationTypes'
import { mapState, mapActions, mapMutations } from 'vuex'
import WebshopOrderSummary from '@/components/Webshop/WebshopOrderSummary'
import WebshopReceipt from '@/components/Webshop/WebshopReceipt'
import { QueryParams } from '@/enums/general'
import { WebshopQueryParams, CartTypes, WebshopPaymentStatuses } from '@/enums/webshop'
import { addLocalCurrency } from '@/utils/general'
import { purchaseEvent } from '@/utils/webshop'

export default {
  name: 'CheckoutConfirmation',
  layout: 'webshop-confirmation',
  components: { WebshopOrderSummary, WebshopReceipt },
  async fetch () {
    await this.getAndSetLoyaltyOrderInformation()
  },
  data () {
    return {
      shippingCosts: 0,
      products: [],
      currency: 'EUR'
    }
  },
  computed: {
    deliveryTimes () {
      return {
        from: this.shipping?.minimumDays || 2,
        to: this.shipping?.maximumDays || 9
      }
    },
    paymentIsPending () {
      return this.$route.query[WebshopQueryParams.status] === WebshopPaymentStatuses.pending
    },
    receiptProps () {
      const cartTotal = this.products.reduce((acc, product) => acc + product.price, 0)

      const credits = parseInt(this.$route.query[WebshopQueryParams.credits]) || 0

      return {
        cartTotal,
        credits,
        shippingCosts: addLocalCurrency(this.shippingCosts, this.country, this.currency),
        type: CartTypes.Confirmation,
        country: this.country
      }
    },
    ...mapState('webshop', {
      shipping: state => state.shipping
    }),
    ...mapState('app', {
      country: state => state.country
    })
  },
  watch: {
    products (newProducts) {
      if (newProducts && newProducts.length) {
        const value = newProducts.reduce((acc, product) => acc + product.price, 0)
        const orderBundleId = this.$route.query[QueryParams.orderBundleId]

        purchaseEvent({
          products: newProducts,
          currency: this.currency,
          value,
          shipping: this.shippingCosts,
          orderBundleId
        })
      }
    }
  },
  created () {
    this.resetCart()
  },
  methods: {
    async getAndSetLoyaltyOrderInformation () {
      try {
        const orderBundleId = this.$route.query[QueryParams.orderBundleId]
        const { products, shipmentCostsInCurrencyOfCountry, currencyOfCountry } = await this.getLoyaltyOrderInformation({ orderBundleId })

        this.shippingCosts = shipmentCostsInCurrencyOfCountry
        this.currency = currencyOfCountry || 'EUR'
        this.products = Object.keys(products).map(key => ({
          price: products[key].amount,
          name: products[key].description,
          sizeLabel: products[key].size,
          productId: products[key].loyaltyProductId,
          slug: products[key].slug,
          quantity: products[key].quantity,
          color: products[key].color,
          category: products[key].category
        }))
      } catch (error) {
        this.$ota.general.logError(error)
      }
    },
    ...mapActions('webshop', {
      getLoyaltyOrderInformation: GET_LOYALTY_ORDER_INFORMATION
    }),
    ...mapMutations('webshop', {
      resetCart: RESET_CART
    })
  }
}
</script>

<style lang="postcss" scoped>

</style>
